module.exports = __webpack_public_path__ + "static/media/icon-eye-white.67cc6538.svg";